import { PaymentMethod, PaymentMethodItem, PaymentMethodsType } from '@cargos/sprintpay-models';
import { NotesFormGroupType } from 'src/app/shared/modules/cart/cart-summary/notes/models/notes-form';
import { TermsOfUseFormGroupType } from 'src/app/shared/modules/cart/lib-cart/balance/terms-of-use/models/terms-of-use-form';
//Todo: Eliminar
export interface PaymentMethodSelected {
    readonly id?: 'authenticatedPaymentMethod';
    paymentAccount?: unknown;
    method: PaymentMethodsType;
    token?: string;
}
//Todo: Eliminar
export interface PaymentMethodGuestSelected {
    readonly id?: 'guestPaymentMethod';
    paymentMethod: PaymentMethodsType;
    token?: string;
}

export interface TermsOfUseForm {
    isValidForm: boolean;
    termsOfUseFormGroup: TermsOfUseFormGroupType | null;
}

export interface NotesForm {
    isValidForm: boolean;
    notesFormGroup: NotesFormGroupType | null;
}

export const paymentMethodGuestInitialValues = null;

export const termsOfUseValidInitialValues = {
    isValidForm: false,
    termsOfUseFormGroup: null,
};

export const notesValidInitialValues = {
    isValidForm: false,
    notesFormGroup: null,
};
//Todo: Eliminar
export interface PaymentMethodComplete {
    paymentMethodComplete: PaymentMethod | PaymentMethodItem | null;
    name: PaymentMethodsType;
    token?: string;
}
//Todo: Eliminar
export interface PaymentMethodDetails {
    billingAddress?: BillingAddress;
    bin?: string;
    cardholderName?: string;
    cardType?: string;
    createdAt?: Date;
    customerId?: string;
    customerLocation?: string;
    expirationMonth: string;
    expirationYear: string;
    imageUrl?: string;
    last4: string;
    commercial?: string;
    debit?: string;
    durbinRegulated?: string;
    healthcare?: string;
    payroll?: string;
    prepaid?: string;
    productId?: string;
    countryOfIssuance?: string;
    issuingBank?: string;
    uniqueNumberIdentifier?: string;
    subscriptions?: [];
    token?: string;
    updatedAt?: Date;
    verification?: {
        amount?: number;
        avsErrorResponseCode?: string;
        avsPostalCodeResponseCode?: string;
        avsStreetAddressResponseCode?: string;
        currencyIsoCode?: string;
        cvvResponseCode?: string;
        gatewayRejectionReason?: string;
        processorResponseCode?: string;
        processorResponseText?: string;
        processorResponseType?: string;
        networkResponseCode?: string;
        networkResponseText?: string;
        networkTransactionId?: string;
        merchantAccountId?: string;
        status?: string;
        id?: string;
        creditCard?: CreditCard;
        billingAddress?: BillingAddress;
        createdAt?: Date;
        riskData?: RiskData;
        threeDSecureInfo?: string;
        graphQLId?: string;
    };
    accountType?: string;
    venmoSdk?: boolean;
    networkTokenized?: boolean;
    maskedNumber?: string;
    expirationDate?: string;
    expired?: boolean;
    default?: boolean;
}
//Todo: Eliminar
interface CreditCard {
    billingAddress?: string;
    bin?: string;
    cardholderName?: string;
    cardType?: string;
    createdAt?: Date;
    customerId?: string;
    customerLocation?: string;
    expirationMonth?: string;
    expirationYear?: string;
    imageUrl?: string;
    last4?: string;
    commercial?: string;
    debit?: string;
    durbinRegulated?: string;
    healthcare?: string;
    payroll?: string;
    prepaid?: string;
    productId?: string;
    countryOfIssuance?: string;
    issuingBank?: string;
    uniqueNumberIdentifier?: string;
    subscriptions?: [];
    token?: string;
    updatedAt?: number;
    verification?: string;
    accountType?: string;
    venmoSdk?: boolean;
    networkTokenized?: boolean;
    maskedNumber?: string;
    expirationDate?: string;
    expired?: boolean;
    default?: boolean;
}
//Todo: Eliminar
interface BillingAddress {
    company?: string;
    countryCodeAlpha2?: string;
    countryCodeAlpha3?: string;
    countryCodeNumeric?: string;
    countryName?: string;
    createdAt?: Date;
    customerId?: string;
    extendedAddress?: string;
    firstName?: string;
    id?: string;
    lastName?: string;
    locality?: string;
    phoneNumber?: string;
    postalCode?: string;
    region?: string;
    recipientName?: string;
    streetAddress?: string;
    updatedAt?: number;
}
//Todo: Eliminar
interface RiskData {
    deviceDataCaptured?: boolean;
    liabilityShift?: string;
    decisionReasons?: [];
    decision?: string;
    fraudServiceProvider?: string;
    id?: string;
    transactionRiskScore?: string;
}
